<div mat-dialog-content [innerHTML]="information.message"></div>
<div mat-dialog-actions align="end">
  @for (navigationButton of information.navigationButtons; track navigationButton) {
    <button
      mat-button
      color="primary"
      [mat-dialog-close]="true"
      (click)="navigateToUrl(navigationButton.toUrl)">
      {{ navigationButton.label }}
    </button>
  }
  <button mat-button
    mat-dialog-close
    cdkFocusInitial>
    Ok
  </button>
</div>
